import React from 'react';

export const EnFlag = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="12"
    viewBox="0 0 32 24"
    fill="none"
  >
    <mask
      id="mask0_270_67363"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="32"
      height="24"
    >
      <rect width="32" height="24" fill="white" />
    </mask>
    <g mask="url(#mask0_270_67363)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0V24H32V0H0Z"
        fill="#F7FCFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 0H14V10H0V14H14V24H18V14H32V10H18V0Z"
        fill="#F50302"
      />
    </g>
  </svg>
);
